<template>
	<div id="app">
		<div @click="docs" class="topbar">
			<div class="bar">
				<img src="./assets/LOGO.png" alt="" />
				<div class="flex bartext">
					<div class="bartext bartext_bc">客服外包</div>
					<span class="bartext">呼叫中心</span>
					<span class="bartext">品牌视觉</span>
					<div class="bartext bartext_bc">抖音运营</div>
					<span class="bartext">私域运营</span>
					<span class="bartext">成功案例</span>
					<span class="bartext">关于我们</span>
				</div>
				<div class="free">免费试用</div>
				<div class="zxgw"></div>
			</div>
		</div>
		<div class="deal">
			<div class="dealtitle">
				<img src="./assets/deal.png" alt="" />
				交易动态
			</div>
			<div class="dealtext">
				<HorizontalTextSlider :sliderData="sliderData" :totalWidth="1200" :amount="3" :height="50" />
			</div>
		</div>
		<div class="kefu">
			<span class="kefutitle">专业客服服务 解决四大角色实际需求</span>
			<span class="kefutitle2">1000名3年以上经验客服，蝉联外包客服金牌淘拍档 </span>
			<div class="kefucard" style="margin-bottom: 20px;">
				<div class="kefucard1">
					<span class="cardtitle">售前客服</span>
					<div class="cardicon">
						<img src="./assets/cpjs.png" alt="">
						<img src="./assets/xszh.png" alt="">
						<img src="./assets/cdcf.png" alt="">
						<img src="./assets/hpgz.png" alt="">
					</div>
					<div class="cardtext">
						<span>产品介绍</span>
						<span>销售转化</span>
						<span>催单催付</span>
						<span>货品跟踪</span>
					</div>
				</div>
				<div class="kefucard1" style="margin-left: 20px;">
					<span class="cardtitle">售后客服</span>
					<div class="cardicon">
						<img src="./assets/kdcx.png" alt="">
						<img src="./assets/afkh.png" alt="">
						<img src="./assets/khwh.png" alt="">
						<img src="./assets/kddj.png" alt="">
					</div>
					<div class="cardtext">
						<span>快递查询</span>
						<span>安抚客户</span>
						<span>客户维护</span>
						<span>快递对接</span>
					</div>
				</div>
			</div>
			<div class="kefucard">
				<div class="kefucard1">
					<span class="cardtitle">专席客服</span>
					<div class="cardicon">
						<img src="./assets/ppkf.png" alt="">
						<img src="./assets/jxkh.png" alt="">
						<img src="./assets/lhpb.png" alt="">
						<img src="./assets/dfw.png" alt="">
					</div>
					<div class="cardtext">
						<span>品牌客服</span>
						<span>绩效考核</span>
						<span>灵活排班</span>
						<span>1对1服务</span>
					</div>
				</div>
				<div class="kefucard1" style="margin-left: 20px;">
					<span class="cardtitle">定制客服</span>
					<div class="cardicon">
						<img src="./assets/yxkf.png" alt="">
						<img src="./assets/wlkf.png" alt="">
						<img src="./assets/dqkf.png" alt="">
						<img src="./assets/sykf.png" alt="">
					</div>
					<div class="cardtext">
						<span>游戏客服</span>
						<span>物流客服</span>
						<span>店群客服</span>
						<span>私域客服</span>
					</div>
				</div>
			</div>
		</div>
		<div class="pingtai">
			<div class="pttext">
				<span class="pingtaititle">承接平台</span>
				<span class="pingtaitext">支持全部主流平台</span>
			</div>
			<div class="ptlogo">
				<div class="pticon">
					<img src="./assets/tb.png" alt="">
					<span>淘宝</span>
				</div>
				<div class="pticon">
					<img src="./assets/tm.png" alt="">
					<span>天猫</span>
				</div>
				<div class="pticon">
					<img src="./assets/jd.png" alt="">
					<span>京东</span>
				</div>
				<div class="pticon">
					<img src="./assets/pdd.png" alt="">
					<span>拼多多</span>
				</div>
				<div class="pticon">
					<img src="./assets/dd.png" alt="">
					<span>抖店</span>
				</div>
				<div class="pticon">
					<img src="./assets/ks.png" alt="">
					<span>快手</span>
				</div>
				<div class="pticon">
					<img src="./assets/wd.png" alt="">
					<span>微店</span>
				</div>
			</div>
		</div>
		<div class="fuwu">
			<span class="kefutitle fuwutitle1">客服八大核心服务 构建企业新壁垒</span>
			<span class="kefutitle2 ">1000名3年以上经验客服，蝉联外包客服金牌淘拍档 </span>
			<div class="kefubox" style="margin-top: 39px;">
				<div class="kefubox1">
					<span class="boxtitle">专业循环培训</span>
					<span class="boxtext">3+2+2培训模式</span>
					<span class="boxtext">专职培训师定期进行培训复</span>
				</div>
				<div class="kefubox2" style="margin: 0 1rem;">
					<span class="boxtitle" style="color: #fff;">专业质检体系</span>
					<span class="boxtext" style="color: #fff;">人工质检＋复盘优化</span>
					<span class="boxtext" style="color: #fff;">自主研发质检系统实时监控</span>
				</div>
				<div class="kefubox1">
					<span class="boxtitle">专业转化团队</span>
					<span class="boxtext">500＋平台认证师</span>
					<span class="boxtext">定期考试持证上岗</span>
				</div>
			</div>
			<div class="kefubox" style="margin-top: 39px;">
				<div class="kefubox2">
					<span class="boxtitle" style="color: #fff;">7×24小时服务</span>
					<span class="boxtext" style="color: #fff;">多类目TOP商家合作背书，专业客</span>
					<span class="boxtext" style="color: #fff;">服管理团队，商家永久五星客服</span>
				</div>
				<img src="./assets/center.png" alt="" />
				<div class="kefubox2">
					<span class="boxtitle" style="color: #fff;">在线履约合同</span>
					<span class="boxtext" style="color: #fff;">按效果付费</span>
					<span class="boxtext" style="color: #fff;">0元使用，不满意可退款</span>
				</div>
			</div>
			<div class="kefubox" style="margin-top: 39px;">
				<div class="kefubox1">
					<span class="boxtitle">标准数据指标</span>
					<span class="boxtext">平台指标监控</span>
					<span class="boxtext">制定标准化店铺考核指标</span>
				</div>
				<div class="kefubox2" style="margin: 0 1rem;">
					<span class="boxtitle" style="color: #fff;">五星级服务商</span>
					<span class="boxtext" style="color: #fff;">10年外包经验</span>
					<span class="boxtext" style="color: #fff;">淘拍档多平台优秀服务商</span>
				</div>
				<div class="kefubox1">
					<span class="boxtitle">品牌合作信赖</span>
					<span class="boxtext">多类目TOP商家合作背书，专业客</span>
					<span class="boxtext">服管理团队，商家永久五星客服</span>
				</div>
			</div>
		</div>
		<div class="kao">
			<span class="kefutitle kaotitle1">严格的服务数据考核体系</span>
			<span class="kefutitle2 kaotitle2">平响时间小于30s，答问比提升120%，询单转化率提升5%~20%</span>
			<img src="./assets/khtx.png" alt="">
		</div>
		<div class="bg">
			<img src="./assets/bg1.png" alt="" />
		</div>
		<div class="pinpai">
			<span class="kefutitle pintitle1">品牌合作案例</span>
			<span class="kefutitle2 pintitle2">累计服务超过20个行业3000家企业，口碑极佳</span>
			<div class="logo">
				<div class="cpmlogo">
					<img src="./assets/bql.png" alt="" />
				</div>
				<div class="cpmlogo">
					<img src="./assets/njr.png" alt="" />
				</div>
				<div class="cpmlogo">
					<img src="./assets/gjgj.png" alt="" />
				</div>
				<div class="cpmlogo">
					<img src="./assets/hd.png" alt="" />
				</div>
				<div class="cpmlogo">
					<img src="./assets/ykyl.png" alt="" />
				</div>
				<div class="cpmlogo">
					<img src="./assets/rhjx.png" alt="" />
				</div>
			</div>
			<div class="logo">
				<div class="cpmlogo">
					<img src="./assets/symm.png" alt="" />
				</div>
				<div class="cpmlogo">
					<img src="./assets/dsn.png" alt="" />
				</div>
				<div class="cpmlogo">
					<img src="./assets/bbz.png" alt="" />
				</div>
				<div class="cpmlogo">
					<img src="./assets/md.png" alt="" />
				</div>
				<div class="cpmlogo">
					<img src="./assets/hx.png" alt="" />
				</div>
				<div class="cpmlogo">
					<img src="./assets/spe.png" alt="" />
				</div>
			</div>
			<div class="logo">
				<div class="cpmlogo">
					<img src="./assets/361.png" alt="" />
				</div>
				<div class="cpmlogo">
					<img src="./assets/sq.png" alt="" />
				</div>
				<div class="cpmlogo">
					<img src="./assets/kl.png" alt="" />
				</div>
				<div class="cpmlogo">
					<img src="./assets/rb.png" alt="" />
				</div>
				<div class="cpmlogo">
					<img src="./assets/tlc.png" alt="" />
				</div>
				<div class="cpmlogo">
					<img src="./assets/rs.png" alt="" />
				</div>
			</div>
			<div class="logo">
				<div class="cpmlogo">
					<img src="./assets/rsd.png" alt="" />
				</div>
				<div class="cpmlogo">
					<img src="./assets/yry.png" alt="" />
				</div>
				<div class="cpmlogo">
					<img src="./assets/dl.png" alt="" />
				</div>
				<div class="cpmlogo">
					<img src="./assets/yh.png" alt="" />
				</div>
				<div class="cpmlogo">
					<img src="./assets/bjr.png" alt="" />
				</div>
				<div class="cpmlogo">
					<img src="./assets/ch.png" alt="" />
				</div>
			</div>
		</div>

		<div class="kaohe">
			<span class="kefutitle kaotitle1">严格的服务数据考核体系 </span>
			<span class="kefutitle2 kaotitle2">平响时间小于30s，答问比提升120%，询单转化率提升5%~20%</span>
			<img src="./assets/sjfw.png" alt="">
		</div>
		<div class="bottom">
			<img src="./assets/LOGOfooter.png" alt="" />
		</div>
		<div class="footer">
			<div class="footer-left">
				<div class="footer-one">
					<div style="display: flex;align-items: center;margin-right: 5rem;">
						<img src="https://omo-oss-image.thefastimg.com/portal-saas/
						new2022090515481403772/cms/image/88d1c942-69f6-491f-9c41-b56
						d4e29d920.png_104xaf.png" alt="瑞创">
						<div class="footer-left">
							<span class="footer-text1">7×24销售售后服务</span>
							<span class="footer-text2">全年无休，急速响应</span>
						</div>
					</div>
					<div style="display: flex;align-items: center;margin-right: 5rem;">
						<img src="https://omo-oss-image.thefastimg.com/portal-saas/
						new2022090515481403772/cms/image/bec22b81-4743-4dfe-aacf-5507
						ed036854.png_104xaf.png" alt="瑞创">
						<div class="footer-left">
							<span class="footer-text1">资质认证</span>
							<span class="footer-text2">多平台资质认证服务商</span>
						</div>
					</div>
					<div style="display: flex;align-items: center;margin-right: 5rem;">
						<img src="https://omo-oss-image.thefastimg.com/portal-saas/
						new2022090515481403772/cms/image/50c59de7-7338-489b-b9e2-c06
						8494bc5dd.png_104xaf.png" alt="瑞创">
						<div class="footer-left">
							<span class="footer-text1">支付安全</span>
							<span class="footer-text2">在线履约，按效果付费</span>
						</div>
					</div>
					<div style="display: flex;align-items: center;">
						<img src="https://omo-oss-image.thefastimg.com/portal-saas/
						new2022090515481403772/cms/image/4c127504-ad1d-463e-bd8e-770
						739d76ec4.png_104xaf.png" alt="瑞创">
						<div class="footer-left">
							<span class="footer-text1">多对1团队服务</span>
							<span class="footer-text2">项目组多人服务对接</span>
						</div>
					</div>
				</div>
				<div class="footer-two">
					<div class="footer-left" style="margin-top: 1.5rem;margin-left: 1rem;">
						<span
							style="color: rgba(255,255,255,1); font-size: 20px;margin-bottom: 0.5rem;font-weight: 800;">联系我们</span>
						<span class="footer-text2" style="margin-bottom: 0.5rem;">广东省深圳市坪山区金牛西路11号益科大厦12楼</span>
						<span class="footer-text2" style="margin-bottom: 0.5rem;">山东省临沂市兰山区北园路与东岳庙街中道大厦五楼</span>
						<span class="footer-text2" style="margin-bottom: 0.5rem;">浙江省杭州市上城区智谷国际人才大厦2幢801</span>
					</div>
					<div style="display: flex;margin-top: 1.5rem;margin-left: 12rem;">
						<div class="footer-left" style="font-size: 1rem;">
							<span style="margin:1rem 0;">叶经理</span>
							<span>15069999899</span>
						</div>
						<img src="https://omo-oss-image.thefastimg.com/portal-saas/new2022090515481403772/
						cms/image/d186cfab-ee43-4d55-97d1-f4500982e6aa.jpg_186xaf.jpg" alt="">
					</div>
					<div style="display: flex;margin-top: 1.5rem;margin-left: 6rem;">
						<div class="footer-left" style="font-size: 1rem;">
							<span style="margin:1rem 0;">任经理</span>
							<span>17661688887</span>
						</div>
						<img src="https://omo-oss-image.thefastimg.com/portal-saas/new2022090515481403772/
						cms/image/e7f76b49-7b58-4743-8204-e7de06419753.jpg_186xaf.jpg" alt="">
					</div>
				</div>
				<div class="footer-three">
					<div class="footer-left" @click="docs">
						<span style="font-size: 1.25rem;font-weight: normal;line-height: 1.5;color: rgba(255,255,255,1);font-weight: 800;
							">帮助中心</span>
						<span>订购流程</span>
						<span>收费标准</span>
						<span>商务合作</span>
					</div>
					<div class="footer-left" @click="docs" style="margin-left: 13rem;">
						<span style="font-size: 1.25rem;font-weight: normal;line-height: 1.5;color: rgba(255,255,255,1);font-weight: 800;
							">合作方式</span>
						<span>履约合同</span>
						<span>线下合约</span>
						<span>平台担保</span>
					</div>
					<div class="footer-left" @click="docs" style="margin-left: 13rem;">
						<span style="font-size: 1.25rem;font-weight: normal;line-height: 1.5;color: rgba(255,255,255,1);font-weight: 800;
							">安全保障</span>
						<span>合同流程</span>
						<span>法律效力</span>
						<span>账户安全</span>
					</div>
					<div class="footer-left" @click="docs" style="margin-left: 13rem;">
						<span style="font-size: 1.25rem;font-weight: normal;line-height: 1.5;color: rgba(255,255,255,1);font-weight: 800;
							">关于我们</span>
						<span>公司简介</span>
						<span>行业咨询</span>
						<span>联系我们</span>
					</div>
				</div>
			</div>
			<img style="position: relative;bottom:3rem;" src="https://omo-oss-image.thefastimg.com/portal-saas/new2022090515481403772/cms/image/9ca1ae5c-569e-4645-9f1a-b69b3ab4c1fa.png_560xaf.png" alt="">
		</div>
		<div class="last">
			
			<span>版权所有 2023 山东嘉客网络科技有限公司 SEO标签 <a href="http://beian.miit.gov.cn">鲁ICP备2023025810号-1 </a></span>
			<img src="./assets/kxwz.png" alt="" />
		</div>
	</div>
</template>

<script>
	import HorizontalTextSlider from './components/HorizontalTextSlider.vue'
	// import left from './components/new_file.vue'
	export default {
		name: 'app',
		components: {
			HorizontalTextSlider

		},
		data() {
			return {
				sliderData: [{
						title: '1个小时前 以1000元购买【拼多多客服外包】',
					},
					{
						title: '1个小时前 以600元购买【抖音客服外包】',
					},
					{
						title: '2个小时前 以500元购买【快手客服外包】',
					},
					{
						title: '3个小时前 以800元购买【天猫客服外包】',
					},
					{
						title: '3个小时前 以300元购买【抖音客服外包】',
					},
					{
						title: '1个小时前 以400元购买【京东客服外包】',
					},
					{
						title: '2个小时前 以600元购买【淘宝客服外包】',
					},
					{
						title: '2个小时前 以300元购买【抖音客服外包】',
					},
					{
						title: '3个小时前 以500元购买【快手客服外包】',
					},
					{
						title: '4个小时前 以800元购买【拼多多客服外包】',
					},
					{
						title: '1个小时前 以400元购买【淘宝客服外包】',
					}
				]

			}
		},
		methods: {
			docs() {
				location.reload();

			},

		},
	}
</script>

<style>
	#app {}

	.topbar {
		width: 100%;
		height: 50.625rem;
		cursor: pointer;
		background-image: url('assets/topbc.jpg');
		background-repeat: no-repeat;
		background-size: 100%;

	}

	.bar {
		height: 5rem;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #fff;
	}

	.bar img {
		height: 3.25rem;
		margin-left: 7rem;
		margin-right: 9rem;
	}

	.flex {
		display: flex;
		align-items: center;
	}

	.bartext {
		font-size: 1rem;
		color: #fff;
		margin-left: 4rem;
	}

	.bartext_bc {
		height: 5rem;
		padding-top: 3.7rem;
		background: url(https://omo-oss-image.thefastimg.com/portal-saas/new2022090515481403772/cms/image/705588c5-eb52-454b-9e10-7100e79e9e72.gif) no-repeat top 40px center;
	}

	.free {
		font-size: 14px;
		color: rgba(255, 255, 255, 1);
		border-style: solid;
		border-width: 1px;
		border-color: rgba(255, 255, 255, 1);
		border-radius: 1.25rem;
		padding: 0.5rem 1rem;
		margin-left: 3rem;

	}

	.zxgw {
		width: 12.5rem;
		height: 3.75rem;
		background-image: url('assets/zxgw.png');
		background-repeat: no-repeat;
		background-size: 100%;
		margin-left: 2rem;
	}

	.deal {
		width: 100%;
		height: 8rem;
		background-color: #ffffff;
		box-shadow: 0rem 2rem 3rem 0rem rgba(12, 21, 35, 0.1);
		padding-top: 2rem;
	}

	.deal img {
		width: 29px;
		height: 28px;
		margin-right: 1rem;
	}

	.dealtitle {
		margin-left: 24rem;
		font-family: SourceHanSansCN-Bold;
		font-size: 24px;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 0px;
		color: #000000;
		display: flex;
		align-items: center;
	}

	.dealtext {
		font-family: SourceHanSansCN-Regular;
		font-size: 1rem;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 0rem;
		color: #000000;
		margin-left: 24rem;
	}

	.kefu {
		width: 100%;
		height: 45rem;
		background-color: #ffffff;
		margin-top: 4rem;
	}

	.kefutitle {
		font-family: SourceHanSansCN-Bold;
		font-size: 42px;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 0px;
		color: #000000;
		margin-left: 39rem;
		margin-top: 4rem;
	}

	.kefutitle2 {
		display: block;
		font-family: SourceHanSansCN-Regular;
		font-size: 20px;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 0px;
		color: #666666;
		margin-left: 46rem;
		margin-top: 1rem;
		margin-bottom: 2rem;
	}

	.kefucard {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 390px;
	}

	.kefucard1 {
		width: 35rem;
		height: 15rem;
		background-color: #ffffff;
		box-shadow: 0px 30px 50px 0px rgba(12, 21, 35, 0.1);
		border-radius: 16px;
	}

	.cardtitle {
		font-family: SourceHanSansCN-Bold;
		font-size: 32px;
		font-weight: normal;
		font-stretch: normal;
		line-height: 72px;
		letter-spacing: 0px;
		color: #000000;
		margin-top: 3rem;
		margin-left: 3rem;
	}

	.cardicon {
		margin-top: 30px;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	.cardicon img {
		display: flex;
	}

	.cardtext {
		display: flex;
		align-items: center;
		justify-content: space-around;
		font-family: SourceHanSansCN-Medium;
		font-size: 20px;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 0px;
		color: #000000;
		margin-top: 30px;
	}

	.pingtai {
		width: 100%;
		height: 14rem;
		background-image: url('assets/ptbc.png');
		background-size: 100%;
		background-repeat: no-repeat;
		display: flex;
	}

	.pttext {
		display: flex;
		flex-direction: column;
		margin-left: 24rem;
		margin-top: 4rem;
	}

	.pingtaititle {
		font-family: SourceHanSansCN-Bold;
		font-size: 3rem;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 0rem;
		color: #ffffff;
		margin-bottom: 1rem;
	}

	.pingtaitext {
		font-family: SourceHanSansCN-Regular;
		font-size: 1rem;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 0rem;
		color: #999999;
	}

	.ptlogo {
		width: 50rem;
		height: 7rem;
		display: flex;
		font-family: SourceHanSansCN-Regular;
		font-size: 1rem;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 0rem;
		color: #ffffff;
		margin-left: 18rem;
		margin-top: 4rem;
	}

	.pticon {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-right: 3rem;
	}

	.pticon img {
		width: 5rem;
		height: 5rem;
		margin-bottom: 1rem;
	}

	.fuwu {
		width: 100%;
		height: 51rem;
		background-color: #f7f7f7;
		padding-top: 4rem;
	}

	.fuwutitle1 {
		margin-left: 40rem;
	}

	.kefubox {
		display: flex;
		align-items: center;
		padding-left: 390px;
	}

	.kefubox img {
		width: 14rem;
		height: 9rem;
		box-shadow: inset 0rem 0rem 0rem 0rem rgba(0, 0, 0, 0.15);
		opacity: 0.7;
		margin: 0 5.5rem;
	}

	.kefubox1 {
		width: 23rem;
		height: 12rem;
		background-color: #ffffff;
		border-radius: 16px;
		display: flex;
		flex-direction: column;
		text-align: center;
		box-shadow: 0px 30px 50px 0px rgba(12, 21, 35, 0.1);
	}

	.boxtitle {
		font-family: SourceHanSansCN-Bold;
		font-size: 30px;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 0px;
		color: #000000;
		margin-bottom: 29px;
		margin-top: 30px;
	}

	.boxtext {
		font-family: SourceHanSansCN-Regular;
		font-size: 20px;
		font-weight: normal;
		font-stretch: normal;
		line-height: 30px;
		letter-spacing: 0px;
		color: #333333;
	}

	.kefubox2 {
		width: 23rem;
		height: 12rem;
		background-color: #224bdd;
		border-radius: 16px;
		display: flex;
		flex-direction: column;
		text-align: center;
		box-shadow: 0px 30px 50px 0px rgba(12, 21, 35, 0.1);
	}

	.kao {
		width: 100%;
		height: 49rem;
		background-color: #ffffff;
		padding-top: 4rem;
	}

	.kao img {
		width: 75rem;
		height: 37rem;
		margin-left: 22rem;
	}

	.kaotitle1 {
		margin-left: 46rem;
	}

	.kaotitle2 {
		margin-left: 42rem;
	}

	.bg {
		width: 100%;
		height: 24rem;
		background-color: #000000;

	}

	a {
		text-decoration: none;
		color: #fff;
	}

	.bg img {
		width: 100%;
		height: 24rem;
	}

	.pinpai {
		width: 100%;
		height: 43rem;
		background-color: #f7f7f7;
		padding-top: 4rem;
	}

	.pintitle1 {
		margin-left: 52rem;
	}

	.pintitle2 {
		margin-left: 47rem;
	}

	.logo {
		display: flex;
		align-items: center;
		padding-left: 24rem;
	}

	.cpmlogo {
		width: 11rem;
		height: 6rem;
		background-color: #ffffff;
		border-radius: 1rem;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 1rem;
		margin-bottom: 1rem;
	}

	.kaohe {
		width: 100%;
		height: 33rem;
		background-color: #ffffff;
		padding-top: 4rem;
	}

	.kaohe img {
		width: 72rem;
		height: 18rem;
		margin-left: 24rem;
		margin-top: 2rem;
	}

	.bottom {
		width: 100%;
		height: 8rem;
		background-color: #f7f7f7;
		/* opacity: 0.7; */
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		line-height: 24px;
		text-align: center;
	}

	.bottom img {
		width: 10rem;
		height: 2.5rem;
	}

	.footer {
		width: 100%;
		height: 30.625rem;
		display: flex;
		background-image: url(https://omo-oss-image1.thefastimg.com/portal-saas/new2022090515481403772/cms/image/973a7039-a62e-4bb5-b288-b157935d51a7.jpg);
		background-repeat: no-repeat;
		background-size: 100%;
	}
	.footer img{
		width: 30rem;
		height: 33.75rem;
		
		
	}
	.footer-left {
		display: flex;
		flex-direction: column;
	}

	.footer-one {
		display: flex;
		align-items: center;
		color: #fff;
		margin-left: 10rem;
		margin-top: 3rem;
	}

	.footer-one img {
		width: 3.125rem;
		height: 3.125rem;
		margin-right: 0.6rem;
	}

	.footer-text1 {
		font-size: 1.125rem;
		color: rgba(255, 255, 255, 1);
		margin-bottom: 0.3rem;
	}

	.footer-text2 {
		font-size: 0.875rem;
		color: rgba(255, 255, 255, 1);
	}

	.footer-two {
		width: 70rem;
		height: 9.625rem;
		border-radius: 0.1875rem;
		border-style: solid;
		border-width: 1px;
		border-color: rgba(255, 255, 255, 0.6);
		margin-left: 10rem;
		margin-top: 2rem;
		color: #fff;
		display: flex;

	}

	.footer-two img {
		width: 6.875rem;
		height: 6.875rem;
		margin-left: 1.5rem;
	}

	.footer-three {
		display: flex;
		font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
		color: #fff;
		font-size: 1rem;
		margin-left: 10rem;
		margin-top: 1rem;
		line-height: 2;
		cursor: pointer;
	}
	.last{
		width: 100%;
		height: 8rem;
		background-color: rgba(61,1,157,1);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		line-height: 24px;
		text-align: center;
		color: #fff;
	}
	.last img{
		width: 8.1875rem;
		height: 2.9375rem;
	}
</style>